'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var QuestionMarkJpg = require("../../../../src/question-mark.jpg").default;

var questionMark = QuestionMarkJpg;

var badImage = Curry._1(Css.style, {
      hd: Css.borderRadius(Css.px(99)),
      tl: /* [] */0
    });

function $$Image(Props) {
  var src = Props.src;
  var className = Props.className;
  var errorClassName = Props.errorClassName;
  var fallbackOpt = Props.fallback;
  var fallback = fallbackOpt !== undefined ? Caml_option.valFromOption(fallbackOpt) : undefined;
  var match = React.useState(function () {
        return /* Good */0;
      });
  var setState = match[1];
  if (match[0]) {
    if (errorClassName !== undefined) {
      if (fallback !== undefined) {
        return React.createElement("img", {
                    className: errorClassName + " " + badImage,
                    src: fallback
                  });
      } else {
        return React.createElement("img", {
                    className: errorClassName + " " + badImage,
                    src: questionMark
                  });
      }
    } else if (fallback !== undefined) {
      return React.createElement("img", {
                  className: className + " " + badImage,
                  src: fallback
                });
    } else {
      return React.createElement("img", {
                  className: className + " " + badImage,
                  src: questionMark
                });
    }
  } else {
    return React.createElement("img", {
                className: className,
                src: src,
                onError: (function (_event) {
                    return Curry._1(setState, (function (_previousState) {
                                  return /* Failed */1;
                                }));
                  })
              });
  }
}

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5) {
  var tmp = {
    src: prim0,
    className: prim1
  };
  if (prim2 !== undefined) {
    tmp.errorClassName = Caml_option.valFromOption(prim2);
  }
  if (prim3 !== undefined) {
    tmp.fallback = Caml_option.valFromOption(prim3);
  }
  if (prim4 !== undefined) {
    tmp.key = prim4;
  }
  return tmp;
}

var make = $$Image;

exports.makeProps = makeProps;
exports.make = make;
/* questionMark Not a pure module */
